export default __webpack_public_path__ + "static/AgrandirTight-708d02f3b4cc3d0929a87f72b66d4b62.woff";